import { excludeSpecialCharacters } from '../../../../../utils/validation'

export function getFirstNameFieldNextValue(event) {
  const nextEvent = { ...event }

  nextEvent.target.value = excludeSpecialCharacters(event.target.value)

  return nextEvent
}
